var map = {
	"./check.svg": 7548,
	"./cross.svg": 8455,
	"./ergochair.svg": 3566,
	"./icons/android-chrome-192x192.png": 5096,
	"./icons/android-chrome-512x512.png": 1887,
	"./icons/apple-touch-icon.png": 3558,
	"./icons/favicon-16x16.png": 7362,
	"./icons/favicon-32x32.png": 897,
	"./icons/mstile-144x144.png": 9482,
	"./icons/mstile-150x150.png": 4866,
	"./icons/mstile-310x150.png": 5470,
	"./icons/mstile-310x310.png": 984,
	"./icons/mstile-70x70.png": 1386,
	"./icons/safari-pinned-tab.svg": 726,
	"./ruler.svg": 4450,
	"resources/assets/images/check.svg": 7548,
	"resources/assets/images/cross.svg": 8455,
	"resources/assets/images/ergochair.svg": 3566,
	"resources/assets/images/icons/android-chrome-192x192.png": 5096,
	"resources/assets/images/icons/android-chrome-512x512.png": 1887,
	"resources/assets/images/icons/apple-touch-icon.png": 3558,
	"resources/assets/images/icons/favicon-16x16.png": 7362,
	"resources/assets/images/icons/favicon-32x32.png": 897,
	"resources/assets/images/icons/mstile-144x144.png": 9482,
	"resources/assets/images/icons/mstile-150x150.png": 4866,
	"resources/assets/images/icons/mstile-310x150.png": 5470,
	"resources/assets/images/icons/mstile-310x310.png": 984,
	"resources/assets/images/icons/mstile-70x70.png": 1386,
	"resources/assets/images/icons/safari-pinned-tab.svg": 726,
	"resources/assets/images/ruler.svg": 4450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3802;